import { Component, OnInit } from '@angular/core';
import { PrFormConstructor } from '@app/components/pr-form/pr-form.contructor';
import { Product } from '@app/forms/subscription/definition/interface/Pledge';
import { paymentFrequencyOptions } from '@app/forms/subscription/services/ref';
import { SubscriptionFacadeService } from '@app/forms/subscription/services/subscription-facade.service';
import { productList } from '../utile';
import { EaSubscriptionBuilder } from './ea-subscription-form.builder';

@Component({
    selector: 'payment-frequency',
    templateUrl: './payment-frequency.component.html',
    styleUrls: ['./payment-frequency.component.scss'],
    standalone: false
})
export class PaymentFrequencyComponent
  extends EaSubscriptionBuilder
  implements OnInit
{
  options: any = paymentFrequencyOptions;

  sessionConsultant: boolean;

  tvaRate: number = 20;
  productEnum = productList;
  table = [];
  monthlyTotalTTC: number;
  annualyTotalTTC: number;
  amountForMonth: number;
  totalAmountForMonth: number;
  monthsToPay: String[];
  extraMonthToPay: number;
  subscriptionProduct: Product;
  yearlyPrestationProduct: any[] = [];
  uniqPrestationProduct: any[] = [];
  oneTimePaymentItems: any[] = [];
  choices: any[] = [];
  schedulePayment: any[] = [];
  totalTva: number = 0;
  remainderPayment: number = 0;
  contractActive: boolean;
  constructor(
    protected formConstructor: PrFormConstructor,
    private subscriptionFacade: SubscriptionFacadeService,
  ) {
    super(formConstructor);
  }

  ngOnInit() {
    this.contractActive =
      this.subscriptionFacade?.getPledge()?.products?.[0].parameters?.isContractActive;
    this.sessionConsultant =
      !!this.subscriptionFacade?.getPledge() &&
      !!this.subscriptionFacade?.getUser()?.sessionConsultant;
    const product = this.subscriptionFacade.getPledge()?.products?.[0];
    this.subscriptionProduct = product;
    const result = this.buildProductFromEnum(product);
    this.table = result;
    this.monthsToPay = this.calculateMonthToPay();
    this.extraMonthToPay = 12 - this.monthsToPay.length;
    this.updateProductList();
    this.monthlyTotalTTC = this.calculateTotalTTC(this.table, true);
    this.annualyTotalTTC = this.calculateTotalTTC(this.table, false);
    this.amountForMonth =
      this.ommitOnePaymentPrestation(this.monthlyTotalTTC) / 12;
    this.totalAmountForMonth =
      this.extraMonthToPay > 0
        ? this.amountForMonth +
          (this.amountForMonth * this.extraMonthToPay) / this.monthsToPay.length
        : this.amountForMonth;
    this.initOneTimePaymentItems();
    this.choices = [];
    this.schedulePayment = [];
    this.setRemainderPayment();
    this.initInvoiceObject();
    this.calculateTotalTva();

    this.subscriptionFacade.initForm(this, {
      totalInvoice:
        !this.subscriptionProduct?.parameters?.paymentFrequency ||
        this.subscriptionProduct?.parameters?.paymentFrequency ===
          'ANNUALLY_PAYMENT'
          ? this.annualyTotalTTC
          : this.monthlyTotalTTC,
      monthlyInvoice:
        this.subscriptionProduct?.parameters?.paymentFrequency ===
        'MONTHLY_PAYMENT'
          ? this.totalAmountForMonth
          : 0,
      choices: this.choices,
      schedulePayment: this.schedulePayment,
      totalTva: this.totalTva,
      remainderPayment: this.remainderPayment,
    });

    this.products
      ?.get('0.parameters.paymentFrequency')
      .valueChanges.subscribe(value => {
        this.monthsToPay = this.calculateMonthToPay();
        this.totalTva = 0;
        this.remainderPayment = 0;
        this.choices = [];
        this.schedulePayment = [];
        this.monthlyTotalTTC = this.calculateTotalTTC(this.table, true);
        this.annualyTotalTTC = this.calculateTotalTTC(this.table, false);
        this.setRemainderPayment();
        this.initInvoiceObject(value);
        this.calculateTotalTva();
        this.updateTotalPayment(value);
      });
  }

  private updateTotalPayment(value: any) {
    this.products
      .get('0')
      .get('parameters')
      .get('totalInvoice')
      .setValue(
        value === 'ANNUALLY_PAYMENT'
          ? this.annualyTotalTTC
          : this.monthlyTotalTTC,
      );
    this.products
      .get('0')
      .get('parameters')
      .get('totalInvoice')
      .updateValueAndValidity();

    this.products
      .get('0')
      .get('parameters')
      .get('monthlyInvoice')
      .setValue(value === 'MONTHLY_PAYMENT' ? this.totalAmountForMonth : 0);
    this.products
      .get('0')
      .get('parameters')
      .get('monthlyInvoice')
      .updateValueAndValidity();

    this.products
      .get('0')
      .get('parameters')
      .get('choices')
      .setValue(this.choices);
    this.products
      .get('0')
      .get('parameters')
      .get('choices')
      .updateValueAndValidity();

    this.products
      .get('0')
      .get('parameters')
      .get('schedulePayment')
      .setValue(this.schedulePayment);
    this.products
      .get('0')
      .get('parameters')
      .get('schedulePayment')
      .updateValueAndValidity();

    this.products
      .get('0')
      .get('parameters')
      .get('totalTva')
      .setValue(this.totalTva.toFixed(2));
    this.products
      .get('0')
      .get('parameters')
      .get('totalTva')
      .updateValueAndValidity();

    this.products
      .get('0')
      .get('parameters')
      .get('remainderPayment')
      .setValue(this.remainderPayment.toFixed(2));
    this.products
      .get('0')
      .get('parameters')
      .get('remainderPayment')
      .updateValueAndValidity();
  }

  private addPropertyNumber(product: Product) {
    return product?.parameters?.additionalPropertyTotal || 0;
  }

  onSubmit() {
    this.form.markAsDirty();
    this.subscriptionFacade.submitPledge(this);
  }

  prev() {
    this.subscriptionFacade.previousStep();
  }

  /**
   * Gets enum objects based on the product and enumKey.
   */
  getEnumObjects(product: Product, enumKey: string) {
    if (!product[enumKey]) return undefined;

    return product[enumKey]
      .map(enumName => this.buildEnumObject(product, enumKey, enumName))
      .filter(obj => obj !== undefined);
  }

  /**
   * Constructs enum object.
   */
  buildEnumObject(product: Product, enumKey: string, enumName: string) {
    const enumObject = this.productEnum[enumKey][enumName];
    if (!enumObject) return undefined;

    if (
      enumObject.customField &&
      product[enumObject.customField] !== undefined
    ) {
      return this.createCustomFieldObject(
        enumObject,
        product[enumObject.customField],
      );
    }

    return enumObject;
  }

  /**
   * Creates a custom field object based on enumObject and value.
   */
  createCustomFieldObject(enumObject, value) {
    const customFieldObj = { ...enumObject };
    customFieldObj.value = value;
    return customFieldObj;
  }

  /**
   * Gets all keys of productEnum.
   */
  getCategoryKeys() {
    return Object.keys(this.productEnum);
  }

  /**
   * Builds product from enum by iterating over all category keys.
   */
  buildProductFromEnum({ parameters }) {
    return this.getCategoryKeys()
      .map(categoryKey => this.getEnumObjects(parameters, categoryKey))
      .filter(categoryObjects => categoryObjects)
      .reduce((acc, categoryObjects) => acc.concat(categoryObjects), []);
  }

  calculateTotalTTC(result: any, monthlyPayment: boolean) {
    let tradeDiscount =
      this.subscriptionProduct?.parameters?.tradeDiscount > 0
        ? this.subscriptionProduct?.parameters?.tradeDiscount
        : 0;
    let total = result.reduce((total, item) => {
      if (item.label === 'Bien supplémentaire') {
        if (monthlyPayment) {
          total +=
            item.monthlyPriceTTC *
            this.subscriptionProduct?.parameters?.additionalPropertyNumber;
        } else {
          total +=
            item.annuallyPriceTTC *
            this.subscriptionProduct?.parameters?.additionalPropertyNumber;
        }
      } else {
        if (monthlyPayment) {
          total += item.monthlyPriceTTC;
        } else {
          total += item.annuallyPriceTTC;
        }
      }

      return total;
    }, 0);

    return this.parseFloat((total - tradeDiscount).toFixed(2));
  }

  ommitOnePaymentPrestation(monthlyTotalTTC: number) {
    this.table.map(item => {
      if (item.oneTimePayment) {
        monthlyTotalTTC -= item.monthlyPriceTTC;
      }
    });

    return monthlyTotalTTC;
  }

  calculateMonthToPay2() {
    const today = new Date();
    const finalDateMission = new Date(
      this.subscriptionProduct?.parameters?.finalDateMission,
    );

    if (finalDateMission.getFullYear() > today.getFullYear()) {
      finalDateMission.setDate(31);
      finalDateMission.setMonth(11);

      today.setFullYear(today.getFullYear() + 1);
      today.setDate(1);
      today.setMonth(0);
    } else {
      finalDateMission.setFullYear(today.getFullYear());
    }

    const remainingMonths: string[] = [];

    while (today < finalDateMission) {
      remainingMonths.push(
        new Intl.DateTimeFormat('fr-FR', { month: 'long' }).format(today),
      );
      today.setMonth(today.getMonth() + 1);
    }

    return remainingMonths;
  }

  calculateMonthToPay() {
    const today = new Date();
    const finalDateMission = new Date('12/31/' + today.getFullYear());

    const remainingMonths: string[] = [];

    while (today < finalDateMission) {
      remainingMonths.push(
        new Intl.DateTimeFormat('fr-FR', { month: 'long' }).format(today),
      );
      today.setMonth(today.getMonth() + 1);
    }

    return remainingMonths;
  }

  getAdditionnalPropertyLabelForMonth(row: any) {
    return (
      this.subscriptionProduct?.parameters?.additionalPropertyNumber +
      (this.subscriptionProduct?.parameters?.additionalPropertyNumber > 1
        ? ' Biens supplémentaires = '
        : ' Bien supplémentaire = ') +
      row?.monthlyPrice *
        this.subscriptionProduct?.parameters?.additionalPropertyNumber +
      '€ TTC/mois'
    );
  }

  initOneTimePaymentItems() {
    this.table.map(item => {
      if (item?.oneTimePayment) {
        this.oneTimePaymentItems.push(item);
      }
    });
  }

  setRemainderPayment() {
    this.table.map(item => {
      if (item?.oneTimePayment) {
        this.remainderPayment += item?.annuallyPriceTTC;
      }
    });
  }

  isOneTimePayment(row: any) {
    return row?.oneTimePayment;
  }

  updateProductList() {
    if (this.table) {
      this.table = this.table.map(item => {
        if (
          item?.label === 'IRPP' ||
          item?.label === 'IFI' ||
          item?.label === 'Mission sociale' ||
          item?.label === 'Reprise de comptabilité'
        ) {
          const yearlyPrice = item?.value;
          const monthlyPrice = this.parseFloat((yearlyPrice / 12).toFixed(2));
          const annuallyPriceTTC = yearlyPrice;
          const monthlyPriceTTC = annuallyPriceTTC;
          const annuallyPriceHT = parseFloat(
            (annuallyPriceTTC / (1 + this.tvaRate / 100)).toFixed(2),
          );
          const monthlyPriceHT = annuallyPriceHT;
          delete item.value;

          return {
            ...item,
            yearlyPrice,
            monthlyPrice,
            annuallyPriceTTC,
            monthlyPriceTTC,
            annuallyPriceHT,
            monthlyPriceHT,
          };
        }

        if (this.contractActive) {
          if (
            item?.label === 'Pack Essentiel' ||
            item?.label === 'Pack revenus fonciers' ||
            item?.label === 'Pack revenus fonciers avec dispositif' ||
            item?.label === 'Reprise de comptabilité'
          ) {
            const yearlyPrice = item?.value;
            const monthlyPrice = this.parseFloat((yearlyPrice / 12).toFixed(2));
            const annuallyPriceTTC = yearlyPrice;
            const monthlyPriceTTC = annuallyPriceTTC;
            const annuallyPriceHT = parseFloat(
              (annuallyPriceTTC / (1 + this.tvaRate / 100)).toFixed(2),
            );
            const monthlyPriceHT = annuallyPriceHT;
            delete item.value;

            return {
              ...item,
              yearlyPrice,
              monthlyPrice,
              annuallyPriceTTC,
              monthlyPriceTTC,
              annuallyPriceHT,
              monthlyPriceHT,
            };
          }
        }

        return item;
      });
    }
  }

  initInvoiceObject(value?: any) {
    const startDateMission = new Date(
      this.subscriptionProduct?.parameters?.startDateMission,
    );
    const finalDateMission = new Date(
      this.subscriptionProduct?.parameters?.finalDateMission,
    );

    this.table.map(item => {
      this.choices.push({
        date:
          'Exercice du ' +
          this.formateDate(startDateMission) +
          ' au ' +
          this.formateDate(finalDateMission),
        label: item.label,
        quantity:
          item.label === 'Bien supplémentaire'
            ? this.subscriptionProduct.parameters.additionalPropertyNumber
            : 1,
        priceHT:
          !value || value === 'ANNUALLY_PAYMENT' || item.oneTimePayment
            ? item.annuallyPriceHT
            : item.monthlyPriceHT,
        tva: this.tvaRate + '%',
        priceTTC:
          !value || value === 'ANNUALLY_PAYMENT' || item.oneTimePayment
            ? item.annuallyPriceTTC
            : item.monthlyPriceTTC,
      });
    });

    if (value && value === 'MONTHLY_PAYMENT') {
      for (let i = 0; i < this.monthsToPay.length; i++) {
        this.schedulePayment.push({
          date: this.getSchedulePaymentDate(i),
          value:
            i == 0
              ? (this.totalAmountForMonth + this.remainderPayment).toFixed(2)
              : this.totalAmountForMonth.toFixed(2),
        });
      }
    }
  }

  calculateTotalTva() {
    this.choices.map(item => {
      let val = parseFloat(item.priceHT);
      if (item?.label === 'Bien supplémentaire') {
        val =
          val * this.subscriptionProduct?.parameters?.additionalPropertyNumber;
      }
      if (!isNaN(val)) {
        this.totalTva += (val * this.tvaRate) / 100;
      }
    });
  }

  getSchedulePaymentDate(monthIndex: number) {
    const today = new Date();
    const date1 = new Date(new Date().setDate(10));
    const date2 = new Date(new Date().setDate(20));
    const tempDate = new Date(new Date().setDate(10));

    let finalDate = new Date(tempDate.setMonth(today.getMonth() + monthIndex));

    if (today >= date1 && today < date2) {
      finalDate = new Date(date2.setMonth(today.getMonth() + monthIndex));
    }

    if (today >= date2) {
      finalDate = new Date(
        finalDate.getFullYear(),
        finalDate.getMonth() + 1,
        0,
      );
    }

    return this.formateDate(finalDate);
  }

  formateDate(date: Date) {
    const jour = (date.getDate() < 10 ? '0' : '') + date.getDate();
    const mois = (date.getMonth() + 1 < 10 ? '0' : '') + (date.getMonth() + 1);
    const annee = date.getFullYear();

    return `${jour}/${mois}/${annee}`;
  }

  getFixedDecimal(value: number) {
    const formattedValue = value.toFixed(2);
    return parseFloat(formattedValue) !== parseInt(formattedValue)
      ? formattedValue
      : parseInt(formattedValue);
  }
}
